import type { DirectiveDescriptor } from '@mdxeditor/editor';

import { WP_PLAYLIST_MDX_DIRECTIVE_NAME } from './wpPlaylistMdxDirectiveConstants';
import { WPPlaylistMdxDirectiveEditor } from './WPPlaylistMdxDirectiveEditor';

export const WPPlaylistMdxDirectiveDescriptor: DirectiveDescriptor = {
  name: WP_PLAYLIST_MDX_DIRECTIVE_NAME,
  testNode(node) {
    return node.name === WP_PLAYLIST_MDX_DIRECTIVE_NAME;
  },
  Editor: WPPlaylistMdxDirectiveEditor,
  hasChildren: false,
  attributes: [],
};
